import { defineMessages } from '@atlassian/jira-intl';
import type { MessageDescriptorV2 as MessageDescriptor } from '@atlassian/jira-intl/src/v2/types.tsx';

type Messages = {
	fieldNamePlaceholder: MessageDescriptor;
	cannotRenameField: MessageDescriptor;
	defaultValueShow: MessageDescriptor;
	defaultValueClearMenu: MessageDescriptor;
	renameAliasedField: MessageDescriptor;
	removeField: MessageDescriptor;
	cannotRemoveFieldTooltip: MessageDescriptor;
	cannotRenameOrReorderFieldTooltip: MessageDescriptor;
	cannotEditOrReorderFieldTooltip: MessageDescriptor;
	cannotEditFieldTooltip: MessageDescriptor;
	expandFieldButton: MessageDescriptor;
	collapseFieldButton: MessageDescriptor;
	toggleFieldButton: MessageDescriptor;
};

export const messages: Messages = defineMessages({
	fieldNamePlaceholder: {
		id: 'project-settings-apps.issue-type-page.fields.field.field-name-placeholder',
		defaultMessage: 'Enter field name',
		description: 'Placeholder for field "Name" input; displayed when the name is empty',
	},
	cannotRenameField: {
		id: 'project-settings-apps.issue-type-page.field.cannot-rename-field',
		defaultMessage: "You can't rename this field",
		description: 'Tooltip that explains why the "Rename field" button is disabled',
	},
	defaultValueShow: {
		id: 'project-settings-apps.issue-type-page.field.default-value-show',
		defaultMessage: 'Set default value',
		description: "Menu item to show an input for configuring the field's default value",
	},
	defaultValueClearMenu: {
		id: 'project-settings-apps.issue-type-page.field.default-value-clear-menu',
		defaultMessage: 'Clear default value',
		description: "Menu item to clear the field's default value and hide the default value input",
	},
	renameAliasedField: {
		id: 'project-settings-apps.issue-type-page.field.rename-aliased-field',
		defaultMessage: 'Rename field',
		description: 'Button that allows changing Field name in case it has an alias.',
	},
	removeField: {
		id: 'project-settings-apps.issue-type-page.field.remove-field',
		defaultMessage: 'Remove',
		description: 'Button that removes Field from Issue Type.',
	},
	cannotRemoveFieldTooltip: {
		id: 'project-settings-apps.issue-type-page.field.cannot-remove-field-tooltip',
		defaultMessage:
			'{productOrPluginThatCreatedThisField} created this field. You can’t remove it.',
		description: 'Some fields cannot be removed',
	},
	cannotRenameOrReorderFieldTooltip: {
		id: 'project-settings-apps.issue-type-page.field.cannot-rename-or-reorder-field-tooltip',
		defaultMessage:
			'{productOrPluginThatCreatedThisField} created this field. You can’t rename or reorder it.',
		description: 'Message to explain why some fields cannot be renamed or reordered.',
	},
	cannotEditOrReorderFieldTooltip: {
		id: 'project-settings-apps.issue-type-page.field.cannot-edit-or-reorder-field-tooltip',
		defaultMessage:
			'{productOrPluginThatCreatedThisField} created this field. You can’t edit or reorder it.',
		description: 'Message to explain why some fields cannot be edited or reordered.',
	},
	cannotEditFieldTooltip: {
		id: 'project-settings-apps.issue-type-page.field.cannot-edit-field-tooltip',
		defaultMessage: '{productOrPluginThatCreatedThisField} created this field. You can’t edit it.',
		description: 'Message to explain why some fields cannot be edited.',
	},
	expandFieldButton: {
		id: 'project-settings-apps.issue-type-page.field-associated.expand-field-button',
		defaultMessage: 'Open field configuration',
		description: 'Label of an icon that opens field configuration card',
	},
	collapseFieldButton: {
		id: 'project-settings-apps.issue-type-page.field-associated.collapse-field-button',
		defaultMessage: 'Close field configuration',
		description: 'Label of an icon that closes field configuration card',
	},
	toggleFieldButton: {
		id: 'project-settings-apps.issue-type-page.field-associated.toggle-field-button',
		defaultMessage: `{field, select, 
            null {}
            other {{field} - }
        }{isOpen, select, 
            true {Close}
            false {Open}
            other {}
        } field configuration`,
		description: 'Label of an icon that open/close field configuration card along with field name',
	},
});
